import React, { Component } from "react";
import { ellipsis } from "../../../../utils/common.utils";
//images
import crown from "../../../../images/score/escrown.png";
import Image from "../../../common/Image";

export default class TeamFFAStandings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leaderBoardType: props.leaderBoardType,
      participant: props.participant,
      tournamentDetails: props.tournamentDetails,
      key: props.index,
    };
    //this.gameUrl = scoreCardGameURL(props.tournamentDetails?.gameDetails?.name)
  }

  componentDidMount() {
    //getLeaderBoardDetails(this.props.tournamentDetails._id, this.setLeaderBoardDetails)
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      leaderBoardType: newProps.leaderBoardType,
      participant: newProps.participant,
      isTeamGame: newProps.isTeamGame,
      key: newProps.index,
    });
  }

  getData = () => {
    const { participant, leaderBoardType, key } = this.state;
    if (leaderBoardType === "STAGE") {
      return (
        <div className="col-6 my-1" key={key}>
          <div className="participant-card p-3">
            <div className="row">
              <div className="col-1 d-flex flex-column me-2">
                <p className="fs-14 fw-700 my-0" style={{ color: key == 0 ? "#FFE420" : "white" }}>
                  #{key + 1}
                </p>
                <img
                  src={crown}
                  alt=""
                  style={{ height: "12px", width: "12px", display: key == 0 ? "block" : "none" }}
                />
              </div>
              <div className="col-5 d-flex flex-column p-0">
                <div className="d-flex">
                  <Image
                    src={participant.teamDetails?.logo?.url}
                    param={participant.teamDetails?.name}
                    className="rounded-circle"
                    height="25px"
                    width="25px"
                  />
                  <div>
                    <p className="fs-10 fw-600 my-0">
                      {ellipsis(participant.teamDetails?.name, 9)}
                    </p>
                    <p className="text-white-50 fw-600 my-0 fs-12">Kills: {participant.kills}</p>
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <p className="text-white-50 fw-600 my-0 fs-12">
                    Matches Won-{participant.noOfGamesWonCount}
                  </p>
                </div>
              </div>
              <div className="col-4 p-0">
                {participant.individualScore.map((player, k) => {
                  return (
                    <div className="d-flex justify-content-between pe-1" key={k}>
                      <p className="text-white fw-600 my-0 fs-12">
                        {ellipsis(player?.participantDetails?.inGameName, 7)}
                      </p>
                      <p className="text-white-50 fw-600 my-0 fs-12">{`${player.kills}/${player.deaths}/${player.assists}`}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="col-12 col-md-6 col-lg-6 my-1" key={key}>
          <div className="participant-card p-3">
            <div className="row">
              <div className="col-1 d-flex flex-column me-2">
                <p className="fs-14 fw-700 my-0" style={{ color: key == 0 ? "#FFE420" : "white" }}>
                  #{key + 1}
                </p>
                <img
                  src={crown}
                  alt=""
                  style={{ height: "12px", width: "12px", display: key == 0 ? "block" : "none" }}
                />
              </div>
              <div className="col-5 d-flex p-0">
                <Image
                  src={participant.teamDetails?.logo?.url}
                  param={participant.teamDetails?.name}
                  className="rounded-circle"
                  height="25px"
                  width="25px"
                />
                <div className="d-flex flex-column">
                  <p className="fs-10 fw-600 my-0">{ellipsis(participant.teamDetails?.name, 9)}</p>
                  <p className="text-white-50 fw-600 my-0 fs-12">Kills: {participant.kills}</p>
                </div>
              </div>
              <div className="col-4 p-0">
                {participant.individualScore.map((score, j) => {
                  return (
                    <div className="d-flex justify-content-between" key={j}>
                      <p className="text-white fw-600 my-0 fs-12">
                        {score.participantDetails?.inGameName}
                      </p>
                      <p className="text-white-50 fw-600 my-0 fs-12">{score.kills}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  render() {
    return this.getData();
  }
}
